import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import InventoryPageImpl from './InventoryPageImpl';
import { openDrawer } from './../../../store/slice/MenuSlice';

export default function InventoryPage() {
    const {mobileView} = useSelector((state)=>state.menu);
    const dispatch = useDispatch();
    const { InventoryList} = useSelector((state)=>state.manufslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':!mobileView}));
    },[]);

    return (
        < InventoryPageImpl />
    )

}